import React from 'react';
import WellInfo from './WellInfo/index';
import { IStyle } from 'Styles';
import IngredientsFilter from './IngredientsFilter';
import ScoringFilters from './ScoringFilters';
export interface FindDropProps {
  setPanelWidth: React.Dispatch<React.SetStateAction<number>>;
}

const FindDrop = (props: FindDropProps) => {
  return (
    <>
      <div id="finddrop-wrapper" style={styles.wellInfoStyle}>
        <div id="finddrop-header" style={styles.header}>
          <div id="finddrop-header-leftsection" style={styles.leftHeaderSection}>
            <div
              id="finddrop-header-left-title"
              style={styles.headerInfoContent}
              title={'Find Drops'}
            >
              {' '}
              {'Find Drops'}{' '}
            </div>
          </div>
        </div>
        <div className="ml-[10px] font-medium text-base mt-2">Filter</div>
        <IngredientsFilter />
        <ScoringFilters />

        <WellInfo id="finddrop-wellinfo-component" />
      </div>
    </>
  );
};

const styles: IStyle = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: '7vh',
    backgroundColor: '#F5F5F5',

    alignItems: 'center',
  },
  leftHeaderSection: {
    marginLeft: '1.5%',
    display: 'flex',
    gap: '1%',
  },
  headerInfoContent: {
    fontWeight: 600,
    textOverflow: 'ellipsis',
    overflow: 'clip',
    marginBlock: 'auto',
  },
  rightHeaderSection: {
    marginRight: '4%',
    display: 'flex',
    gap: '10%',
  },
  filterButton: {
    position: 'absolute',
    right: '3%',
  },
  wellInfoStyle: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  wellInfoStyleWithScoresPanel: {
    position: 'absolute',
    right: '0%',
    width: '62%',
  },
  wellIngredientsScoresVisible: {
    display: 'block',
    position: 'relative',
    maxWidth: '38%',
    border: '1px solid lightgray',
  },
  wellInfoScoresHidden: {
    display: 'none',
  },
};

export default FindDrop;
